<!-- based on https://vuejs.org/v2/examples/modal.html
Prefer to use vue-js-modal instead of this.
 -->
<template>
<transition name="modal">
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="flex">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>
          <div class="modal-close" @click="$emit('close')">❌</div>
        </div>

        <div class="modal-body">
          <slot name="body">
          </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
          </slot>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>

export default {
  name: 'Modal',
  props: {
  },
  computed: {
    indexes() {
      const result = [];
      for (let i = 1; i <= this.size; i++) {
        result.push(i);
      }
      return result;
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  flex: 1;       /* grow so .modal-close sits in the top-right corner */
  min-width: 0;  /* allow long headers to wrap rather than push the X off */
  font-family: Tahoma;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  text-align: center;
  letter-spacing: 0.04em;
  /* black / 80 */
  color: rgba(0, 0, 0, 0.8);
}

.modal-body {
  margin: 20px 0;
}

.modal-close {
  cursor: pointer;
  padding: 10px;
  margin-top: -15px;
  margin-right: -25px;
}


/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
